import { Spinner } from '@nextui-org/react'
import useHomeTrade from '../hooks/useHomeTrade'
import { useEffect } from 'react'
import { useWeb3ModalAccount } from '@web3modal/ethers/react'
import useWalletStore from '@/lib/store/useWalletStore'
import { useTranslation } from 'react-i18next'

export default function HomeTrade() {
	const { t } = useTranslation()
	const { isConnected, address } = useWeb3ModalAccount()
	const isSign = useWalletStore(state => state.isSign)

	const { data: tradeData, ...args } = useHomeTrade()

	const loading = args.isLoading || args.isValidating

	useEffect(() => {
		if (!isSign && isConnected) args.mutate()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isConnected, isSign, address])
	return (
		<div className="relative z-10 my-8 px-2">
			<div className="tail-text-menu w-full text-center text-[1.5625rem]">{t('swap.trade.title')}</div>
			{loading ? (
				<div className="flex min-h-[200px] items-center justify-center">
					<Spinner color="white" size="sm" />
				</div>
			) : (
				<div className="flex flex-col gap-2.5 pt-5">
					{tradeData.orderList.map((item, index) => (
						<div key={index} className="rounded-2xl border border-white/15 bg-white/5 p-4 backdrop-blur">
							<div className="relative flex items-center justify-between gap-2">
								<div className="flex w-[40%] items-center gap-2 text-xs text-white">
									<img src={item.ccies_from_code.logo} className="inline-block h-[2.625rem] w-[2.625rem] shrink-0" alt="" />
									<div className="text-base">
										<div className="line-clamp-1">{item.from_code}</div>
										<span className="line-clamp-1 text-xs">{Number(item.send_amount)}</span>
									</div>
								</div>
								<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M18.2016 12.389L1.59049 12.389L6.64604 17.4446"
										stroke="white"
										strokeWidth="1.44444"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M1.59076 6.61098L18.2019 6.61098L13.1463 1.55542"
										stroke="white"
										strokeWidth="1.44444"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>

								<div className="flex w-[40%] items-center gap-2 text-xs text-white">
									<img src={item.ccies_to_code.logo} className="inline-block h-[2.625rem] w-[2.625rem] shrink-0" alt="" />
									<div className="line-clamp-1 text-base">{item.to_code}</div>
								</div>
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	)
}
